(function() {
  'use strict';

  var progressBar = document.querySelector('.sc-progress-bar');
  var nav = document.querySelector('.sc-nav');
  var hamburger = document.querySelector('.sc-hamburger');
  var mobileMenu = document.querySelector('.sc-mobile-menu');
  var floatCart = document.querySelector('.sc-float-cart');
  var addToCartBtn = document.querySelector('.sc-float-cart-btn');
  var lastScroll = 0;

  function onScroll() {
    var y = window.scrollY;
    var docH = document.documentElement.scrollHeight - window.innerHeight;
    if (progressBar && docH > 0) {
      progressBar.style.transform = 'scaleX(' + (y / docH) + ')';
    }
    if (nav) {
      if (y > 100) nav.classList.add('scrolled');
      else nav.classList.remove('scrolled');
      if (y > 300 && y > lastScroll) nav.classList.add('hidden');
      else nav.classList.remove('hidden');
    }
    if (floatCart) {
      if (y > 400) floatCart.classList.add('visible');
      else floatCart.classList.remove('visible');
    }
    lastScroll = y;
  }

  window.addEventListener('scroll', onScroll, { passive: true });
  onScroll();

  if (hamburger && mobileMenu) {
    hamburger.addEventListener('click', function() {
      hamburger.classList.toggle('open');
      mobileMenu.classList.toggle('open');
    });
    mobileMenu.querySelectorAll('a').forEach(function(a) {
      a.addEventListener('click', function() {
        hamburger.classList.remove('open');
        mobileMenu.classList.remove('open');
      });
    });
  }

  var editionSelect = document.querySelector('[data-edition-select]');
  var editionCartLink = document.querySelector('[data-edition-cart-link]');
  var editionCtaLabel = document.querySelector('[data-edition-cta-label]');
  if (editionSelect) {
    editionSelect.addEventListener('change', function() {
      var opt = editionSelect.options[editionSelect.selectedIndex];
      if (!opt) return;
      var newId = opt.value;
      if (editionCartLink) editionCartLink.setAttribute('href', '/cart/' + newId + ':1');
      if (editionCtaLabel) editionCtaLabel.textContent = opt.textContent.replace(/ — SOLD$/, '').trim();
      if (addToCartBtn) addToCartBtn.dataset.variantId = newId;
    });
  }

  if (addToCartBtn) {
    var CART_ICON = '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="9" cy="21" r="1"/><circle cx="20" cy="21" r="1"/><path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6"/></svg>';
    var CHECK_ICON = '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"/></svg>';
    var ALERT_ICON = '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="10"/><line x1="12" y1="8" x2="12" y2="12"/><line x1="12" y1="16" x2="12.01" y2="16"/></svg>';

    addToCartBtn.addEventListener('click', function() {
      var btn = this;
      var productId = btn.dataset.variantId;
      if (!productId) return;

      btn.classList.add('added');
      btn.setAttribute('aria-label', 'Added to cart');
      btn.innerHTML = CHECK_ICON;

      fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        },
        body: JSON.stringify({ items: [{ id: parseInt(productId), quantity: 1 }] })
      })
      .then(function(res) { return res.json(); })
      .then(function() {
        setTimeout(function() {
          btn.classList.remove('added');
          btn.setAttribute('aria-label', 'Add to cart');
          btn.innerHTML = CART_ICON;
        }, 2000);
      })
      .catch(function() {
        btn.classList.remove('added');
        btn.setAttribute('aria-label', 'Error — try again');
        btn.innerHTML = ALERT_ICON;
        setTimeout(function() {
          btn.setAttribute('aria-label', 'Add to cart');
          btn.innerHTML = CART_ICON;
        }, 2000);
      });
    });
  }

  var reveals = document.querySelectorAll('.sc-reveal, .sc-reveal-left, .sc-reveal-scale');
  var measures = document.querySelectorAll('.sc-measure');

  if ('IntersectionObserver' in window) {
    var observer = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('visible');
          observer.unobserve(entry.target);
        }
      });
    }, { rootMargin: '-8% 0px', threshold: 0.1 });

    reveals.forEach(function(el) { observer.observe(el); });
    measures.forEach(function(el) { observer.observe(el); });
  } else {
    reveals.forEach(function(el) { el.classList.add('visible'); });
    measures.forEach(function(el) { el.classList.add('visible'); });
  }

  var statEls = document.querySelectorAll('[data-count-to]');
  if (statEls.length > 0) {
    var countObserver = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (!entry.isIntersecting) return;
        var el = entry.target;
        var target = el.dataset.countTo;
        var suffix = el.dataset.countSuffix || '';
        var num = parseFloat(target);
        if (isNaN(num)) { el.textContent = target + suffix; return; }
        var isDecimal = target.includes('.');
        var start = performance.now();
        var duration = 1500;
        function animate(now) {
          var elapsed = now - start;
          var progress = Math.min(elapsed / duration, 1);
          var eased = 1 - Math.pow(1 - progress, 4);
          var current = num * eased;
          el.textContent = (isDecimal ? current.toFixed(1) : Math.round(current)) + suffix;
          if (progress < 1) requestAnimationFrame(animate);
        }
        requestAnimationFrame(animate);
        countObserver.unobserve(el);
      });
    }, { threshold: 0.3 });
    statEls.forEach(function(el) { countObserver.observe(el); });
  }

  var tryonBtn = document.querySelector('[data-tryon-trigger]');
  var tryonModal = document.querySelector('[data-tryon-modal]');
  if (tryonBtn && tryonModal) {
    var tryonInput = tryonModal.querySelector('[data-tryon-input]');
    var tryonDrop = tryonModal.querySelector('.sc-tryon-drop');
    var tryonDropImg = tryonModal.querySelector('.sc-tryon-drop-img');
    var tryonResult = tryonModal.querySelector('.sc-tryon-result');
    var tryonResultImg = tryonModal.querySelector('[data-tryon-result]');
    var tryonLoader = tryonModal.querySelector('[data-tryon-loader]');
    var tryonError = tryonModal.querySelector('[data-tryon-error]');
    var tryonSubmit = tryonModal.querySelector('[data-tryon-submit]');
    var tryonSubmitLabel = tryonModal.querySelector('[data-tryon-submit-label]');
    var tryonReset = tryonModal.querySelector('[data-tryon-reset]');
    var tryonDownload = tryonModal.querySelector('[data-tryon-download]');
    var tryonStepResult = tryonModal.querySelector('[data-tryon-step-result]');
    var tryonClosers = tryonModal.querySelectorAll('[data-tryon-close]');

    function normalizeUrl(u) {
      if (!u) return '';
      u = String(u).trim();
      if (!u) return '';
      if (u.indexOf('//') === 0) return window.location.protocol + u;
      if (/^https?:\/\//i.test(u)) return u;
      if (u.charAt(0) === '/') return window.location.origin + u;
      return 'https://' + u.replace(/^\/+/, '');
    }
    var endpoint = normalizeUrl(tryonBtn.dataset.tryonEndpoint);
    var watchUrl = normalizeUrl(tryonBtn.dataset.tryonImage);
    var variantName = tryonBtn.dataset.tryonVariant || '';
    var wristFile = null;
    var wristObjectUrl = null;
    var lastResultUrl = null;
    var currentAbort = null;
    var requestSeq = 0;

    function showTryonBtn() { tryonBtn.classList.add('visible'); }
    function hideTryonBtn() { tryonBtn.classList.remove('visible'); }
    function tryonScroll() { if (window.scrollY > 300) showTryonBtn(); else hideTryonBtn(); }
    window.addEventListener('scroll', tryonScroll, { passive: true });
    tryonScroll();

    function setError(msg) {
      if (msg) { tryonError.textContent = msg; tryonError.hidden = false; }
      else { tryonError.textContent = ''; tryonError.hidden = true; }
    }

    function setSubmitState() {
      tryonSubmit.disabled = !wristFile;
      tryonSubmitLabel.textContent = lastResultUrl ? 'Regenerate' : 'Try It On';
    }

    function clearWrist() {
      if (wristObjectUrl) { URL.revokeObjectURL(wristObjectUrl); wristObjectUrl = null; }
      wristFile = null;
      tryonDropImg.hidden = true;
      tryonDropImg.removeAttribute('src');
      tryonDrop.classList.remove('has-image');
      tryonInput.value = '';
    }

    function clearResult() {
      lastResultUrl = null;
      tryonResultImg.hidden = true;
      tryonResultImg.removeAttribute('src');
      tryonResult.classList.remove('has-result');
      tryonDownload.hidden = true;
      tryonDownload.removeAttribute('href');
      if (tryonStepResult) tryonStepResult.textContent = '02 · Preview';
      tryonModal.classList.remove('has-result');
    }

    function fullReset() {
      if (currentAbort) { try { currentAbort.abort(); } catch (_) {} currentAbort = null; }
      requestSeq++;
      tryonLoader.hidden = true;
      tryonSubmit.classList.remove('is-loading');
      clearWrist();
      clearResult();
      setError('');
      setSubmitState();
    }

    function openModal() {
      tryonModal.hidden = false;
      requestAnimationFrame(function() { tryonModal.classList.add('open'); });
      document.body.classList.add('sc-tryon-locked');
    }

    function closeModal() {
      tryonModal.classList.remove('open');
      document.body.classList.remove('sc-tryon-locked');
      setTimeout(function() {
        tryonModal.hidden = true;
        fullReset();
      }, 280);
    }

    tryonBtn.addEventListener('click', openModal);
    Array.prototype.forEach.call(tryonClosers, function(el) { el.addEventListener('click', closeModal); });
    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape' && tryonModal.classList.contains('open')) closeModal();
    });

    function acceptWristFile(file) {
      if (!file) return false;
      if (!file.type || file.type.indexOf('image/') !== 0) { setError('Please select an image file.'); return false; }
      if (file.size > 10 * 1024 * 1024) { setError('Image is too large (max 10 MB).'); return false; }
      setError('');
      clearResult();
      if (wristObjectUrl) URL.revokeObjectURL(wristObjectUrl);
      wristFile = file;
      wristObjectUrl = URL.createObjectURL(file);
      tryonDropImg.src = wristObjectUrl;
      tryonDropImg.hidden = false;
      tryonDrop.classList.add('has-image');
      setSubmitState();
      return true;
    }

    tryonInput.addEventListener('change', function(e) {
      acceptWristFile(e.target.files && e.target.files[0]);
    });

    // ─── Custom camera capture with framing guide overlay ───
    var camEl = document.querySelector('[data-tryon-camera]');
    if (camEl) {
      var camOpenBtn = tryonModal.querySelector('[data-tryon-camera-open]');
      var camCancelBtn = camEl.querySelector('[data-tryon-camera-cancel]');
      var camCaptureBtn = camEl.querySelector('[data-tryon-camera-capture]');
      var camVideo = camEl.querySelector('[data-tryon-camera-video]');
      var camCanvas = camEl.querySelector('[data-tryon-camera-canvas]');
      var camError = camEl.querySelector('[data-tryon-camera-error]');
      var camStream = null;

      function camSetError(msg) {
        if (!camError) return;
        if (msg) { camError.textContent = msg; camError.hidden = false; }
        else { camError.textContent = ''; camError.hidden = true; }
      }

      function camStopStream() {
        if (!camStream) return;
        try { camStream.getTracks().forEach(function(t) { t.stop(); }); } catch (_) {}
        camStream = null;
        if (camVideo) { try { camVideo.srcObject = null; } catch (_) {} }
      }

      function camClose() {
        camStopStream();
        camEl.hidden = true;
        camSetError('');
        if (camCaptureBtn) camCaptureBtn.disabled = false;
      }

      async function camOpen() {
        if (!navigator.mediaDevices || !navigator.mediaDevices.getUserMedia) {
          setError('Camera is not supported in this browser. Use Upload Photo instead.');
          return;
        }
        camSetError('');
        camEl.hidden = false;
        if (camCaptureBtn) camCaptureBtn.disabled = true;
        try {
          camStream = await navigator.mediaDevices.getUserMedia({
            video: {
              facingMode: { ideal: 'environment' },
              width: { ideal: 1920 },
              height: { ideal: 1080 }
            },
            audio: false
          });
          camVideo.srcObject = camStream;
          // Wait for the video to actually start streaming before enabling capture
          await new Promise(function(resolve) {
            if (camVideo.readyState >= 2) return resolve();
            camVideo.onloadedmetadata = function() { resolve(); };
          });
          try { await camVideo.play(); } catch (_) {}
          if (camCaptureBtn) camCaptureBtn.disabled = false;
        } catch (err) {
          var name = err && err.name;
          var msg = 'Could not access camera.';
          if (name === 'NotAllowedError' || name === 'PermissionDeniedError') {
            msg = 'Camera permission denied. Enable it in your browser settings, or use Upload Photo.';
          } else if (name === 'NotFoundError' || name === 'DevicesNotFoundError') {
            msg = 'No camera found on this device. Use Upload Photo instead.';
          } else if (name === 'NotReadableError' || name === 'TrackStartError') {
            msg = 'Camera is in use by another app. Close it and try again.';
          } else if (location.protocol !== 'https:' && location.hostname !== 'localhost') {
            msg = 'Camera requires HTTPS. Open the site over https:// and try again.';
          }
          camSetError(msg);
        }
      }

      function camCapture() {
        if (!camVideo || !camCanvas || !camStream) return;
        var vw = camVideo.videoWidth, vh = camVideo.videoHeight;
        if (!vw || !vh) { camSetError('Camera not ready yet.'); return; }
        camCanvas.width = vw;
        camCanvas.height = vh;
        var ctx = camCanvas.getContext('2d');
        if (!ctx) { camSetError('Capture failed.'); return; }
        ctx.drawImage(camVideo, 0, 0, vw, vh);
        camCanvas.toBlob(function(blob) {
          if (!blob) { camSetError('Capture failed.'); return; }
          var f = new File([blob], 'wrist-capture.jpg', { type: blob.type || 'image/jpeg' });
          var ok = acceptWristFile(f);
          if (ok) camClose();
          else camSetError('Could not use captured photo.');
        }, 'image/jpeg', 0.92);
      }

      if (camOpenBtn) camOpenBtn.addEventListener('click', camOpen);
      if (camCancelBtn) camCancelBtn.addEventListener('click', camClose);
      if (camCaptureBtn) camCaptureBtn.addEventListener('click', camCapture);
      document.addEventListener('keydown', function(e) {
        if (e.key === 'Escape' && !camEl.hidden) camClose();
      });
      // Make sure stream is killed if the parent try-on modal is closed mid-capture
      var origFullReset = fullReset;
      fullReset = function() {
        if (!camEl.hidden) camClose();
        origFullReset();
      };
    }

    tryonReset.addEventListener('click', fullReset);

    tryonDownload.addEventListener('click', function(e) {
      if (!lastResultUrl) return;
      e.preventDefault();
      var ua = navigator.userAgent || '';
      var isIOS = /iPad|iPhone|iPod/.test(ua) || (ua.indexOf('Mac') !== -1 && 'ontouchend' in document);
      var safeName = (variantName || 'watch').toLowerCase().replace(/\s+/g, '-');
      var filename = 'grandeur-tryon-' + safeName + '.jpg';

      fetch(lastResultUrl)
        .then(function(r) {
          if (!r.ok) throw new Error('fetch failed');
          return r.blob();
        })
        .then(function(blob) {
          // iOS Safari ignores the <a download> attribute, so fall back to the
          // Web Share API which lets users save into Files / Photos.
          if (isIOS && navigator.canShare && navigator.share) {
            var file = new File([blob], filename, { type: blob.type || 'image/jpeg' });
            if (navigator.canShare({ files: [file] })) {
              return navigator.share({ files: [file], title: 'Grandeur Try-On' }).catch(function(err) {
                if (err && err.name === 'AbortError') return;
                throw err;
              });
            }
          }
          // Everywhere else: programmatic <a download> click triggers an
          // immediate save to Downloads with no visible navigation.
          var blobUrl = URL.createObjectURL(blob);
          var temp = document.createElement('a');
          temp.href = blobUrl;
          temp.download = filename;
          temp.rel = 'noopener';
          temp.style.display = 'none';
          document.body.appendChild(temp);
          temp.click();
          document.body.removeChild(temp);
          setTimeout(function() { URL.revokeObjectURL(blobUrl); }, 60000);
        })
        .catch(function() {
          // Network/CORS failure — last resort, open the original URL in a tab
          // so the user can right-click → save.
          window.open(lastResultUrl, '_blank', 'noopener');
        });
    });

    tryonSubmit.addEventListener('click', function() {
      if (!wristFile) { setError('Upload a photo of your wrist first.'); return; }
      if (!endpoint) { setError('Try-on endpoint is not configured.'); return; }
      if (!watchUrl) { setError('No watch image is available for this product.'); return; }
      if (currentAbort) { try { currentAbort.abort(); } catch (_) {} }
      currentAbort = (typeof AbortController !== 'undefined') ? new AbortController() : null;
      var mySeq = ++requestSeq;
      setError('');
      tryonSubmit.disabled = true;
      tryonSubmit.classList.add('is-loading');
      tryonLoader.hidden = false;
      tryonResultImg.hidden = true;
      tryonResult.classList.remove('has-result');
      tryonModal.classList.add('has-result');

      var fetchOpts = { mode: 'cors' };
      if (currentAbort) fetchOpts.signal = currentAbort.signal;

      fetch(watchUrl, fetchOpts)
        .then(function(r) { if (!r.ok) throw new Error('Could not load watch image'); return r.blob(); })
        .then(function(watchBlob) {
          if (mySeq !== requestSeq) throw new DOMException('aborted', 'AbortError');
          var fd = new FormData();
          fd.append('wrist', wristFile, wristFile.name || 'wrist.jpg');
          var watchName = (variantName || 'watch').toLowerCase().replace(/\s+/g, '-') + '.png';
          fd.append('watch', watchBlob, watchName);
          if (variantName) fd.append('variantName', variantName);
          var postOpts = { method: 'POST', body: fd };
          if (currentAbort) postOpts.signal = currentAbort.signal;
          return fetch(endpoint, postOpts);
        })
        .then(function(res) {
          return res.json().then(function(data) { return { ok: res.ok, status: res.status, data: data }; });
        })
        .then(function(out) {
          if (mySeq !== requestSeq) return;
          if (!out.ok) throw new Error((out.data && out.data.error) || 'Generation failed (' + out.status + ')');
          if (!out.data || !out.data.imageUrl) throw new Error('No image returned.');
          // Hard reject anything that isn't a plain https URL — prevents javascript:/data: payloads
          // ending up in <a href> or <img src>.
          if (!/^https:\/\//i.test(String(out.data.imageUrl))) throw new Error('Invalid image URL returned.');
          lastResultUrl = out.data.imageUrl;
          tryonResultImg.src = lastResultUrl;
          tryonResultImg.hidden = false;
          tryonResult.classList.add('has-result');
          tryonDownload.href = lastResultUrl;
          tryonDownload.hidden = false;
          if (tryonStepResult) tryonStepResult.textContent = '02 · Result';
        })
        .catch(function(err) {
          if (mySeq !== requestSeq) return;
          if (err && err.name === 'AbortError') return;
          setError((err && err.message) || 'Generation failed.');
        })
        .finally(function() {
          if (mySeq !== requestSeq) return;
          tryonLoader.hidden = true;
          tryonSubmit.classList.remove('is-loading');
          setSubmitState();
        });
    });
  }

  var isMobile = window.innerWidth < 768;
  var particleContainer = document.querySelector('.sc-particles');
  if (particleContainer) {
    var count = isMobile ? 6 : 20;
    for (var i = 0; i < count; i++) {
      var p = document.createElement('div');
      p.className = 'sc-particle';
      var size = Math.random() * 2 + 1;
      p.style.cssText = 'left:' + (Math.random()*100) + '%;top:' + (Math.random()*100) + '%;width:' + size + 'px;height:' + size + 'px;animation-duration:' + (Math.random()*10+15) + 's;animation-delay:' + (Math.random()*5) + 's;';
      particleContainer.appendChild(p);
    }
  }
})();
